import type { DocTableBlock } from "./blockTypes";

const MIN_ROWS = 1;
const MIN_COLS = 1;
const MAX_ROWS = 50;
const MAX_COLS = 12;

export function normalizeTableRows(rows: string[][]): string[][] {
  if (rows.length === 0) return [[""]];
  const colCount = Math.max(...rows.map((r) => r.length), MIN_COLS);
  return rows.map((row) => {
    const next = [...row];
    while (next.length < colCount) next.push("");
    return next.slice(0, MAX_COLS);
  });
}

export function createDefaultTableRows(cols = 2, dataRows = 2): string[][] {
  return Array.from({ length: dataRows }, () => Array.from({ length: cols }, () => ""));
}

export function addTableRow(block: DocTableBlock): DocTableBlock {
  const cols = block.rows[0]?.length ?? MIN_COLS;
  if (block.rows.length >= MAX_ROWS) return block;
  return {
    ...block,
    rows: [...block.rows, Array.from({ length: cols }, () => "")],
  };
}

export function removeTableRow(block: DocTableBlock, rowIndex: number): DocTableBlock {
  if (block.rows.length <= MIN_ROWS) return block;
  return {
    ...block,
    rows: block.rows.filter((_, i) => i !== rowIndex),
  };
}

export function addTableColumn(block: DocTableBlock): DocTableBlock {
  const cols = block.rows[0]?.length ?? 0;
  if (cols >= MAX_COLS) return block;
  return {
    ...block,
    rows: block.rows.map((row) => [...row, ""]),
  };
}

export function removeTableColumn(block: DocTableBlock, colIndex: number): DocTableBlock {
  const cols = block.rows[0]?.length ?? 0;
  if (cols <= MIN_COLS) return block;
  return {
    ...block,
    rows: block.rows.map((row) => row.filter((_, i) => i !== colIndex)),
  };
}

export function updateTableCell(
  block: DocTableBlock,
  rowIndex: number,
  colIndex: number,
  value: string,
): DocTableBlock {
  return {
    ...block,
    rows: block.rows.map((row, ri) =>
      ri === rowIndex ? row.map((cell, ci) => (ci === colIndex ? value : cell)) : row,
    ),
  };
}

export { MAX_COLS, MAX_ROWS, MIN_COLS, MIN_ROWS };
